import { PropsWithChildren } from 'react';

import type { BehaviorTrackingProps } from '../../../../core/types/behavior-tracking-props.js';
import type { AnnotationsActionsHandler } from '../../../core/components/annotations/types/annotations.js';
import type { TextOverflowOptions } from '../../../core/components/annotations/types/marker.js';
import { XYChartData } from '../../types/xy-chart.js';

/**
 * The props for the `XYChart.Annotations` slot component.
 * @public
 */
export interface XYChartAnnotationsProps extends BehaviorTrackingProps {
  /**
   * Data object for the xy chart.
   */
  data: XYChartData[];
  /**
   * Unique Id required to attach the annotations to its x-axis.
   */
  xAxisId: string;
  /**
   * Flag for showing/hiding track labels
   * @defaultValue false
   */
  showLabels?: boolean;
  /**
   * Amount of tracks visible without scrolling.
   * @defaultValue 3
   */
  fixedTracks?: number;
  /**
   * Custom annotations actions on entry selection.
   */
  annotationsActions?: AnnotationsActionsHandler;
  /**
   * Controls whether annotation text may expand beyond its track boundary or is truncated.
   * @defaultValue 'expand'
   */
  textOverflow?: TextOverflowOptions;
}

/**
 * The `Annotations` slot component for XYChart.
 * @public
 */
export const Annotations = (
  props: PropsWithChildren<XYChartAnnotationsProps>,
) => null;

Annotations['displayName'] = 'XYChart.Annotations';
